// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__I7uI5","signatureBlock":"Footer_signatureBlock__SttqW","signature":"Footer_signature__2l0cD"};